import { render } from "./EditIcon.vue?vue&type=template&id=00cfacfe&scoped=true"
import script from "./EditIcon.vue?vue&type=script&lang=js"
export * from "./EditIcon.vue?vue&type=script&lang=js"

import "./EditIcon.vue?vue&type=style&index=0&id=00cfacfe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00cfacfe"]])

export default __exports__